import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { TyreDiscountsDashboardQueryKeys } from "modules/TyreDiscountsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { TyreDiscount } from "models";

export const useAddTyreDiscountMutation = () =>
  useTypedMutation<TyreDiscount, number>({
    mutationFn: async (payload: TyreDiscount) => (await ApiInstance.post("/tyre_discounts/add", payload, ENV.dealerBaseURL)).data.tyre_discount_id,
    onSuccess: (payload, tyre_discount_id) => {
      const discounts = typedQueryClient.getQueryData(TyreDiscountsDashboardQueryKeys.discounts);
      typedQueryClient.setQueryData(TyreDiscountsDashboardQueryKeys.discounts, [...(discounts || []), { ...payload, id: tyre_discount_id }]);
    }
  });
